import React from 'react';
import moment from 'moment';

var service = {
  getHeaderData(data) {
    return {
      Borates: data.Borates,
      custName: data.custName,
      custAccountNo: data.custAccountNo,
      poolVolume: data.poolVolume,
      testerName: data.testerName,
      poolType: data.poolType,
      branchLogo: 'data:image/png;base64,' + (data.BranchLogoBase64 || data.BranchLogoBytes),
      finish: data.finish,
      groundLevelType: data.groundLevelType,
      testDate: moment(data.testDate),
      nextAnalysis: moment(data.nextAnalysis),
      suPeriod: data.suPeriod,
      ReportType: data.ReportType,
      country: data.country,
    };
  },
  GetShoppingListData(data) {
    return {
      ReportType: data.ReportType,
      ShoppingList: data.ShoppingList,
      poolType: data.poolType,
      country: data.country,
    };
  },
  getMaintenanceData(data) {
    return {
      data: [
        data.maintOne,
        data.maintTwo,
        data.maintThree,
        data.maintFour,
      ].concat(data.additionalMaintItems),
      chemicalBaseTypeID: data.chemicalBaseTypeID,
    };
  },
  getWaterQualityScoreData(data) {
    return {
      ReportType: data.ReportType,
      ShowPoolScores: data.ShowPoolScores,
      SwimmerComfortScore: data.SwimmerComfortScore,
      WaterClarityScore: data.WaterClarityScore,
      SurfaceEquipmentProtectionScore: data.SurfaceEquipmentProtectionScore,
      keyParameters: [
        data.SI,
        {value: data.saturationIndexText},
        data.Salt,
        data.pH,
        data.TotalAlkalinity,
        data.TotalHardness,
        data.TotalBromine,
        data.TDS,
        data.MainParam,
        data.MainParam2,
        data.CYA,
        data.Borates,
      ],
    };
  },
  getCongratulationsData(data) {
    return {
      nextAnalysis: moment(data.nextAnalysis),
    };
  },
  getProblemAreas(data) {
    return {
      ProblemAreas: data.problemAreas,
      ReportType: data.ReportType,
    };
  },
  getFooterData(data) {
    return {
      country: data.country,
      storeAddress: data.storeAddress,
      storeTelephone: data.storeTelephone,
      storeWebsite: data.storeWebsite,
      storeEmail: data.storeEmail,
      storeHours: data.storeHours,
      established: data.established,
      branchLogo: 'data:image/png;base64,' + (data.BranchLogoBase64 || data.BranchLogoBytes),
    };
  },
  getTruBlueData(data) {
    return {
      isDealerTruBlue: data.isDealerTruBlue,
      poolTruBlueStatus: data.poolTruBlueStatus,
      hideTruBlueBanner: data.hideTruBlueBanner,
    };
  },
  getSuggestedProducts(data) {
    return {
      country: data.country,
      chemicalBaseTypeID: data.chemicalBaseTypeID,
      suggestedProducts: data.suggestedProducts,
      version: data.version,
      volume: data.poolType === 'Pool' ? data.poolVolume / 1000 : data.poolVolume,
    };
  },
};

export default service;
